

const footer = document.getElementById( 'contact' );
jQuery( '.blueCta, .getInTouch, [href="#contact"]' ).on( 'click', function( e ) {
    e.preventDefault();
    jQuery( 'html, body' ).animate( {
        scrollTop: jQuery( footer ).offset().top - 0
    }, 400 );
} );